import SeasonalBanner, {
  SeasonalBannerColors,
} from "../../SeasonalBanner/SeasonalBanner"
import useStrings from "../../../localization/useStrings"
import svg from "../../../utils/svg"

const winterColors: SeasonalBannerColors = {
  containerBackground: "linear-gradient(to bottom, #CADDFC 0%, #8FAEF4 100%)",
  titleText: "#6480BD",
  subtitleText: "#30343D",
  urgencyText: "#313B77",
  countdownBox: "#CADDFC",
  countdownValue: "#30343D",
  countdownLabel: "#313B77",
  ctaBackground: "#2B5FF5",
  ctaText: "white",
}

const WinterBanner = () => {
  const strings = useStrings()

  return (
    <SeasonalBanner
      icon={
        <svg.winter.WinterBanner
          height={50}
          width={28}
          style={{ margin: "0 auto", display: "block" }}
        />
      }
      title={strings.winterSale.title}
      colors={winterColors}
      titleFontSize="18px"
    />
  )
}

export default WinterBanner
